import script from "./ReserveActionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReserveActionsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReserveActionsModal.vue?vue&type=style&index=0&id=536174e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536174e0"]])

export default __exports__